import { InvalidArticleError } from '../../domain/errors/InvalidArticleError';
import type { ArticleRepository } from '../../domain/repositories/ArticleRepository.interface';
import type { ArticleCategory } from '../../domain/entities/Article.entity';
import type { ArticleDto } from '../dto/ArticleDto';
import { ApplicationError, type Logger } from '@dma/shared';

export class GetArticlesUseCase {
  constructor(
    private readonly repository: ArticleRepository,
    private readonly logger: Logger
  ) {}

  public async execute(category: ArticleCategory): Promise<ArticleDto[]> {
    try {
      const articles = await this.repository.getPublished(category);
      return articles.map((article) => article.props);
    } catch (error) {
      if (error instanceof InvalidArticleError) {
        this.logger.error('Article content failed domain validation', {
          category,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('ARTICLES_UNAVAILABLE', 'فهرست مطالب در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }
  }
}
